import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-folders-line',
      title: t('organized_research'),
      description: t('organized_research_desc'),
    },
    {
      icon: 'ri-equalizer-line',
      title: t('compare_options'),
      description: t('compare_options_desc'),
    },
    {
      icon: 'ri-camera-lens-line',
      title: t('qc_guide'),
      description: t('qc_guide_desc'),
    },
    {
      icon: 'ri-time-line',
      title: t('save_time'),
      description: t('save_time_desc'),
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            {t('why_spreadsheet')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 rounded-xl bg-white border border-background-200 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${feature.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}